/**
 * Форматирует вывод чисел, разделяя каждые 3 символа заданным separator
 *
 * @param {number, string} price - исходное значение суммы
 * @param separator - разделитель который будет вставлен через каждые 3 символа
 * @returns {string} - отформатированная строка
 */
export function formatPrice(price, separator = " ") {
  return String(price).replace(/(\d)(?=(\d\d\d)+([^\d]|$))/g, `$1${separator}`);
}
